import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../helpers/reducerRegistry'
import { getDataTable, getHeaders, getIds } from '../../../helper'
import { getBusinessGrowthBankThunk } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/industryAnalysis/bank/businessGrowth',
  initialState: {
    activeRowGroupId: undefined,
    isLoading: true,
    ids: [],
    data: {},
    headers: [],
    years: [],
  },
  reducers: {
    changeActiveRow: (state, { payload }) => {
      state.activeRowGroupId = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBusinessGrowthBankThunk.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(
      getBusinessGrowthBankThunk.fulfilled,
      (state, { payload = [] }) => {
        state.isLoading = false
        const ids = getIds(payload)

        if (ids.length) {
          state.ids = ids
          state.data = getDataTable(payload, ids)
          state.headers = getHeaders(payload)
          state.activeRowGroupId = ids[0]
          const { values = [] } = payload[0]
          state.years = values.map((item) => item.realYear)
        }
      },
    )
    builder.addCase(
      getBusinessGrowthBankThunk.rejected,
      (state, { payload = {} }) => {
        state.isLoading = payload.isLoading
      },
    )
  },
})

export const selectIds = (state) => state[slice.name].ids
export const selectActiveRowGroupId = (state) =>
  state[slice.name].activeRowGroupId
export const selectIsLoading = (state) => state[slice.name].isLoading
export const selectData = (state) => state[slice.name].data
export const selectHeaders = (state) => state[slice.name].headers
export const selectRowGroup = (rowGroupId) => (state) =>
  state[slice.name].data[rowGroupId]
export const selectCellData = (rowId, index, colId) => (state) =>
  state[slice.name].data[rowId][index][colId]
export const selectYears = (state) => state[slice.name].years

export const { changeActiveRow } = slice.actions

register(slice.name, slice.reducer)
